import {
    Badge,
    Button,
    IconButton,
    List,
    ListItem,
    ListItemSecondaryAction,
    styled,
    Typography
} from "@mui/material";
import React, {useEffect, useState, useMemo} from "react";
import {THEME_CONFIG} from "../../../config";
import {ArrowDownward, ArrowUpward} from "@mui/icons-material";
import { useTranslation } from 'react-i18next';
import {getTranslatedAnswers} from "../../../functions/getTranslatedAnswers";
import useLanguageStore from "../../../store/languageStore";

Array.prototype.move = function (from, to) {
    this.splice(to, 0, this.splice(from, 1)[0]);
};

const {poll} = THEME_CONFIG

const ReorderQuestion = ({risposte, risposteTranslations, answer, sendAnswer}) => {
    const { t } = useTranslation('questions');
    const { currentLanguage, defaultLanguage } = useLanguageStore();
    const [orderedAnswers, setOrderedAnswers] = useState()

    // Ottieni le risposte tradotte
    const translatedRisposte = useMemo(() => {
        return getTranslatedAnswers(risposte, risposteTranslations, currentLanguage, defaultLanguage);
    }, [risposte, risposteTranslations, currentLanguage, defaultLanguage]);

    useEffect(() => {
        if(answer !== '' && Array.isArray(answer)) {
            // answer contiene risposte nella lingua di default
            // Dobbiamo mapparle alle risposte tradotte usando gli indici
            const translatedFromAnswer = answer.map(originalAnswer => {
                const index = risposte.findIndex(r => r === originalAnswer);
                return index !== -1 && translatedRisposte[index] ? translatedRisposte[index] : originalAnswer;
            });
            setOrderedAnswers(translatedFromAnswer);
        } else {
            setOrderedAnswers(translatedRisposte)
        }
    }, [answer, translatedRisposte, risposte])

    const RispostaStyled = styled(ListItem)({
        border: `2px solid ${poll.default}`,
        borderRadius: '0.7rem',
        background: poll.default,
        margin: '1rem 0',
        cursor: 'pointer',
    })

    function moveUpward(r, i) {
        const newAnswers = [...orderedAnswers]
        newAnswers?.move(i, i-1)

        setOrderedAnswers(newAnswers)
    }

    function moveDownward(r, i) {
        const newAnswers = [...orderedAnswers]
        newAnswers?.move(i, i+1)
        setOrderedAnswers(newAnswers)
    }

    const rispondi = () => {
        if(answer === '') {
            // Mappa orderedAnswers (che contiene risposte tradotte) alle risposte originali
            // basandoci sull'indice delle risposte tradotte
            const originalAnswers = orderedAnswers.map(translatedAnswer => {
                const index = translatedRisposte.findIndex(tr => tr === translatedAnswer);
                return index !== -1 ? risposte[index] : translatedAnswer;
            });
            sendAnswer(originalAnswers)
        }
    }

    return (
        <><List>
            {orderedAnswers?.map((r, i) => (
            <Badge key={i} color="primary" badgeContent={i+1} sx={{display: 'grid'}}
                   overlap="circular"
                   anchorOrigin={{
                       vertical: 'top',
                       horizontal: 'right',
                   }}
            >
                <RispostaStyled style={{
                    width: '100%',
                    //background: computeBkg(r),
                    border: `2px solid ${poll.default}`,
                    color: 'white',
                }}>
                    <Typography variant="h6" fontWeight='400' whiteSpace='pre-line'>
                        {r}
                    </Typography>
                    <ListItemSecondaryAction>
                        <IconButton size='small' disabled={i === 0 || answer !== ''} onClick={() => moveUpward(r, i)}>
                            <ArrowUpward/>
                        </IconButton>
                        <IconButton size='small' disabled={i === translatedRisposte.length-1 || answer !== ''} onClick={() => moveDownward(r, i)}>
                            <ArrowDownward/>
                        </IconButton>
                    </ListItemSecondaryAction>
                </RispostaStyled>
            </Badge>))
            }
        </List>
            <Button sx={{mt: 4}}
                    disabled={answer !== ''}
                    variant='default'
                    onClick={rispondi}>
                {t('reorder.send')}
            </Button>
        </>
    )
}

export default ReorderQuestion
